import styled, { css } from 'styled-components';

export const ChartTitle = styled.h1`
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  color: var(--luft-primary);
`;

export const ChartContainer = styled.div`
  border: 1px solid var(--mid-gray-chart);
  margin: 20px 0;
  padding: 24px;
`;

export const LegendContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DataKeyContainer = styled.div`
  background-color: ${({ backgroundColor }) =>
    backgroundColor && backgroundColor};
  color: white;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  padding: 4px 9px;
  border-radius: 4px;
  text-transform: uppercase;
  margin: 0 5%;
  width: 76px;
  text-align: center;
`;

export const IsPictureLabel = styled.p`
  color: ${({ color }) => color && color};
  font-style: italic;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  margin-right: 10px;
`;

export const PictureStatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5%;
  width: 70px;
  text-align: center;

  i {
    font-size: 14px;
    color: ${({ color }) => color && color};
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 48px;

  p {
    font-size: 12px;
    line-height: 14px;

    strong {
      color: var(--dark-blue);
    }
  }
`;

export const ChartHeaderContainer = styled.div`
  display: flex;
  align-items: center;

  h1 {
    flex: 1;
  }

  button {
    margin-left: 8px;
    border-radius: 4px;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const Col = styled.div`
  ${({ md5 }) =>
    md5 &&
    css`
      @media (min-width: 768px) {
        flex: 0 0 auto;
        width: 41.66666667%;
      }
    `}
  ${({ md7 }) =>
    md7 &&
    css`
      @media (min-width: 768px) {
        flex: 0 0 auto;
        width: 58.33333333%;
      }
    `}
`;
